import { NgModule } from "@angular/core";
import { CarouselSliderComponent } from "@modules/shared/carousel-module/carousel-slider.component";
import { CommonModule } from "@angular/common";

const components = [CarouselSliderComponent];

@NgModule({
	imports: [CommonModule],
	declarations: [components],
	exports: [components]
})
export class CarouselSliderModule {}
